import {RouterModule, Routes} from "@angular/router";
import {NgModule} from "@angular/core";
import {Landing1Component} from "./landing1/landing1.component";

export const landingPagesRoutes: Routes = [
  {
    path: 'welcome', // child route path
    component: Landing1Component, // child route component that the router renders
  },
  {
    path: 'welcome/:copy', // child route path
    component: Landing1Component, // child route component that the router renders
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(landingPagesRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class LandingPagesRoutingModule { }

